import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }

import { computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { gameGet } from "@/common/api/rest/game/game";

import type { GameType } from "@/common/types/game/game";

import TabGameInfos from "@/components/tabs/game/infos.vue";
import TabGameDetails from "@/components/tabs/game/details.vue";
import TabGameImages from "@/components/tabs/game/images.vue";
import TabGameName from "@/components/tabs/game/name.vue";
import TabGameSlug from "@/components/tabs/game/slug.vue";
import TabGameConsole from "@/components/tabs/game/console.vue";
import TabGameRelated from "@/components/tabs/game/related.vue";

import { breadcrumbSimple, iconMenu, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: '[tab]',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const selectedTab = ref("infos");
const gameData = ref<GameType | null>(null);

const gameId = computed(() => route.params.item as string);

const breadcrumbList = computed(() => [
  {
    key: "collections",
    label: t("common.labels.collections"),
    url: `/collection`,
  },
  {
    key: "collection",
    label: t("collection.labels.games"),
    url: `/collection/game`,
  },
  {
    key: "edit",
    label: gameData.value?.name ?? "...",
  },
]);

const menuList = computed(() => [
  {
    key: "infos",
    icon: "field",
    label: t("collection.labels.infos"),
    url: `/collection/game/${gameId.value}/infos`,
  },
  {
    key: "name",
    icon: "no-image",
    label: t("common.labels.other_names"),
    url: `/collection/game/${gameId.value}/name`,
  },
  {
    key: "slug",
    icon: "no-image",
    label: t("slug.labels.slugs"),
    url: `/collection/game/${gameId.value}/slug`,
  },
  {
    key: "image",
    icon: "no-image",
    label: t("collection.labels.images"),
    url: `/collection/game/${gameId.value}/image`,
  },
  {
    key: "details",
    icon: "no-image",
    label: t("collection.labels.details"),
    url: `/collection/game/${gameId.value}/details`,
  },
  {
    key: "console",
    icon: "no-image",
    label: t("collection.labels.consoles"),
    url: `/collection/game/${gameId.value}/console`,
  },
  {
    key: "related",
    icon: "game",
    label: t("collection.labels.related"),
    url: `/collection/game/${gameId.value}/related`,
  },
]);

function back() {
  router.push(`/collection/game`);
}

async function changeMenu(url: string) {
  await fetchData();
  router.push(url);
}

// game
async function fetchData() {
  await gameGet(gameId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        gameData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watch(
  () => route.params.tab,
  () => {
    selectedTab.value = route.params.tab as string;
  },
  {
    immediate: true,
  },
);

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "gamepad",
            size: "2rem"
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" EDITAR GAME ", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default w-8 h-8",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: selectedTab.value,
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs", "active"]),
        (gameData.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (selectedTab.value === 'infos')
                ? (_openBlock(), _createBlock(TabGameInfos, {
                    key: 0,
                    "game-id": gameId.value,
                    game: gameData.value,
                    "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => (fetchData()))
                  }, null, 8, ["game-id", "game"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'details')
                ? (_openBlock(), _createBlock(TabGameDetails, {
                    key: 1,
                    "game-id": gameId.value
                  }, null, 8, ["game-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'name')
                ? (_openBlock(), _createBlock(TabGameName, {
                    key: 2,
                    "game-id": gameId.value
                  }, null, 8, ["game-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'slug')
                ? (_openBlock(), _createBlock(TabGameSlug, {
                    key: 3,
                    "owner-id": gameId.value
                  }, null, 8, ["owner-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'console')
                ? (_openBlock(), _createBlock(TabGameConsole, {
                    key: 4,
                    "owner-id": gameId.value
                  }, null, 8, ["owner-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'related')
                ? (_openBlock(), _createBlock(TabGameRelated, {
                    key: 5,
                    "game-id": gameId.value
                  }, null, 8, ["game-id"]))
                : _createCommentVNode("", true),
              (selectedTab.value === 'image')
                ? (_openBlock(), _createBlock(TabGameImages, {
                    key: 6,
                    "game-id": gameId.value
                  }, null, 8, ["game-id"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})